import React from 'react';
import { ClassOrder } from '../../../../typescript/generated/codegen';
import Select from '../../../common/select/select';

interface SortByProps {
  filters: any;
  setFilters: any;
  side: 'left' | 'right';
}

const SortBy: React.FC<SortByProps> = ({ filters, setFilters, side }) => {
  const handleSetSort = (key: string) => {
    setFilters({ order: key });
  };

  const sortOptions = [
    { label: 'NEWEST', key: ClassOrder.PublishedAtDesc },
    { label: 'OLDEST', key: ClassOrder.PublishedAtAsc },
  ];

  return (
    <Select
      side={side}
      label={
        sortOptions.find(opt => opt.key === filters.order)?.label || 'Sort by'
      }
      options={sortOptions}
      onSelect={handleSetSort}
    />
  );
};

export default SortBy;
